export default __webpack_public_path__ + "static/media/86.65c9e407.jpg";